import * as React from "react";
const SvgReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      d="M16.667 5.44v10.81c0 1.151-.932 2.084-2.083 2.084H5.417a2.083 2.083 0 0 1-2.083-2.083V3.75c0-1.15.933-2.084 2.083-2.084h7.477c.11-.007.226.03.318.123l3.333 3.333a.408.408 0 0 1 .122.318M12.501 2.5H5.417c-.69 0-1.25.56-1.25 1.25v12.5c0 .691.56 1.25 1.25 1.25h9.167c.69 0 1.25-.559 1.25-1.25V5.835h-2.917a.417.417 0 0 1-.416-.417zm.833.59V5h1.91zm-6.25 5.243a.417.417 0 1 1 0-.833h5.833a.417.417 0 0 1 0 .833zm0 2.5a.417.417 0 1 1 0-.833h5.833a.417.417 0 1 1 0 .833zm0 2.5a.417.417 0 1 1 0-.833h4.167a.417.417 0 1 1 0 .833z"
    />
  </svg>
);
export default SvgReportsIcon;